(() => {
  if (window.apScandiQuoteInitialized) return;
  window.apScandiQuoteInitialized = true;

  function initialize(root) {
    if (root.dataset.quoteReady === 'true') return;
    const form = root.querySelector('form');
    const section = document.getElementById(`MainProduct-${root.dataset.sectionId}`) || root.closest('section') || root;
    const field = (key) => root.querySelector(`[data-ap-quote-${key}]`);
    let variants;
    let optionNames;
    let strings;
    try {
      variants = JSON.parse(field('variants').textContent);
      optionNames = JSON.parse(field('options').textContent);
      strings = JSON.parse(field('strings').textContent);
      if (!Array.isArray(variants) || !variants.length || !Array.isArray(optionNames)) return;
    } catch (_) {
      return;
    }
    if (!form) return;
    root.dataset.quoteReady = 'true';
    const picker = Array.from(section.querySelectorAll('variant-radios, variant-selects')).find((item) => item.dataset.section === root.dataset.sectionId);
    const variantInput = field('variant-id');
    const quantity = field('quantity');
    const country = field('country');
    const postcode = field('postcode');
    const submit = field('submit');
    const clientError = field('client-error');
    const details = root.querySelector('.ap-scandi-quote__details');
    const initialVariantId = variantInput.value;
    const requestedQuantity = new URL(window.location.href).searchParams.get('quantity');
    if (requestedQuantity && /^[1-9][0-9]*$/.test(requestedQuantity) && Number.isSafeInteger(Number(requestedQuantity))) quantity.value = requestedQuantity;
    if (window.location.hash === '#ap-scandi-quote') details.open = true;
    let currentVariant = null;
    let currentUrl = null;
    let currentQuantity = 1;
    const currency = new Intl.NumberFormat(root.dataset.locale || 'de', { style: 'currency', currency: root.dataset.currency || 'EUR' });

    function selectedVariant() {
      if (!picker) return variants.find((item) => String(item.id) === initialVariantId) || null;
      let values;
      if (picker.tagName.toLowerCase() === 'variant-radios') {
        values = Array.from(picker.querySelectorAll('fieldset'), (fieldset) => fieldset.querySelector('input[type="radio"]:checked')?.value);
      } else {
        values = Array.from(picker.querySelectorAll('select'), (select) => select.value);
      }
      if (values.length !== optionNames.length || values.some((value) => value === undefined)) return null;
      return variants.find((item) => item.options.length === values.length && item.options.every((option, index) => option === values[index])) || null;
    }

    function displayError(message) {
      clientError.textContent = message || '';
      clientError.hidden = !message;
    }

    function addSummaryRow(list, label, value) {
      const row = document.createElement('div');
      const term = document.createElement('dt');
      const description = document.createElement('dd');
      term.textContent = label;
      description.textContent = value;
      row.append(term, description);
      list.append(row);
    }

    function updatePostcodeRules() {
      const allowedCountry = country.value === 'AT' || country.value === 'DE';
      country.setCustomValidity(allowedCountry ? '' : strings.invalid_country);
      postcode.pattern = country.value === 'DE' ? '[0-9]{5}' : '[0-9]{4}';
      postcode.title = country.value === 'DE' ? strings.postcode_de : strings.postcode_at;
      postcode.setCustomValidity('');
      if (postcode.value && !new RegExp(`^${postcode.pattern}$`).test(postcode.value.trim())) {
        postcode.setCustomValidity(postcode.title);
      }
    }

    function writeBody() {
      if (!currentVariant || !currentUrl) return;
      const lines = [
        strings.request,
        `${strings.product}: ${root.dataset.productTitle}`,
        `${strings.sku}: ${currentVariant.sku}`,
        ...optionNames.map((name, index) => `${name}: ${currentVariant.options[index]}`),
        `${strings.quantity}: ${currentQuantity}`,
        `${strings.price}: ${currency.format(currentVariant.price / 100)}`,
        `${strings.link}: ${currentUrl.href}`,
        '',
        ...['name', 'email', 'phone', 'street', 'postcode', 'city'].map((key) => `${strings[key]}: ${field(key).value}`),
        `${strings.country}: ${country.selectedOptions[0].textContent} (${country.value})`,
        '',
        `${strings.message}:`,
        field('message').value
      ];
      field('body').value = lines.join('\n');
    }

    function synchronize() {
      currentVariant = selectedVariant();
      currentQuantity = Number(quantity.value);
      const validQuantity = Number.isSafeInteger(currentQuantity) && currentQuantity > 0;
      quantity.setCustomValidity(validQuantity ? '' : strings.invalid_quantity);
      const validVariant = Boolean(currentVariant && currentVariant.sku);
      submit.disabled = !validVariant || !validQuantity;
      updatePostcodeRules();
      const list = field('summary');
      list.replaceChildren();
      if (!validVariant) {
        variantInput.value = '';
        field('sku-field').value = '';
        field('options-field').value = '';
        field('link-field').value = '';
        field('sku').textContent = '—';
        field('price').textContent = '—';
        displayError(strings.invalid_variant);
        return false;
      }
      currentUrl = new URL(root.dataset.productUrl, window.location.origin);
      currentUrl.searchParams.set('variant', currentVariant.id);
      variantInput.value = currentVariant.id;
      field('sku-field').value = currentVariant.sku;
      field('options-field').value = optionNames.map((name, index) => `${name}: ${currentVariant.options[index]}`).join(' | ');
      field('link-field').value = currentUrl.href;
      field('sku').textContent = currentVariant.sku;
      field('price').textContent = currency.format(currentVariant.price / 100);
      const returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo) {
        const returnUrl = new URL(currentUrl);
        if (validQuantity) returnUrl.searchParams.set('quantity', currentQuantity);
        returnTo.value = `${returnUrl.pathname}${returnUrl.search}#${root.id}`;
      }
      optionNames.forEach((name, index) => addSummaryRow(list, name, currentVariant.options[index]));
      addSummaryRow(list, strings.quantity, validQuantity ? String(currentQuantity) : '—');
      displayError(validQuantity ? '' : strings.invalid_quantity);
      writeBody();
      return validQuantity;
    }

    section.addEventListener('change', (event) => {
      if (picker?.contains(event.target) || form.contains(event.target)) synchronize();
    });
    form.addEventListener('input', writeBody);
    quantity.addEventListener('input', synchronize);
    postcode.addEventListener('input', updatePostcodeRules);
    country.addEventListener('change', updatePostcodeRules);
    form.addEventListener('invalid', () => {
      details.open = true;
    }, true);
    form.addEventListener('submit', (event) => {
      if (!synchronize()) {
        event.preventDefault();
        details.open = true;
        clientError.focus();
        return;
      }
      ['name', 'email', 'phone', 'street', 'postcode', 'city'].forEach((key) => {
        field(key).value = field(key).value.trim();
      });
      updatePostcodeRules();
      if (!form.checkValidity()) {
        event.preventDefault();
        details.open = true;
        form.reportValidity();
        return;
      }
      writeBody();
    });
    synchronize();
    const status = field('server-error') || field('success');
    if (status) status.focus({ preventScroll: true });
  }

  function initializeWithin(scope) {
    if (scope.matches?.('[data-ap-scandi-quote]')) initialize(scope);
    scope.querySelectorAll('[data-ap-scandi-quote]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  window.addEventListener('pageshow', () => initializeWithin(document));
})();
